export default "/canceled_icon.254655cb-56341a.svg?svgr";